import { IAccount } from "@/modules/auth/types";
import { EServices } from "@/types";
import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";

import { delay } from "@/utils/time";
import { Component, Inject, Mixins, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import Notifications from "../notifications/Notifications";
import VEmptyState from "@/vuetify-extensions/VEmptyState.vue";
import PwaPrompt from "@/components/PwaPrompt.vue";
import StoreService from "@/store";

const AccountModule = namespace("AccountModule");

@Component({
  components: {
    Notifications,
    VEmptyState,
    PwaPrompt,
  },
})
export default class Dashboard extends Mixins(JackocoinsNetworkManagerMixin) {
  primaryNavLinks = [
    {
      icon: "mdi-qrcode",
      text: "Sell",
      link: "/dashboard/sell",
    },
    {
      icon: "mdi-format-list-bulleted",
      text: "Transactions",
      link: "/dashboard/transactions",
    },
    // {
    //   icon: "mdi-wallet-outline",
    //   text: "Wallets",
    //   link: "/dashboard/wallets",
    // },
    {
      icon: "mdi-clock-outline",
      text: "Activities",
      link: "/dashboard/activities",
    },
  ];

  secondaryNavLinks = [
    {
      icon: "mdi-bank-outline",
      text: "Banks and Payments",
      link: "/dashboard/banks",
    },
    {
      icon: "mdi-account-group-outline",
      text: "Referrals",
      link: "/dashboard/referrals",
    },
    {
      icon: "mdi-numeric-1-box-multiple-outline",
      text: "Leaderboard",
      link: "/dashboard/leaderboard",
    },
    {
      icon: "mdi-chat-outline",
      text: "Help Center",
      link: "/dashboard/help",
    },
    {
      icon: "mdi-power",
      text: "Log out",
      link: "",
      click: () => this.logout(),
    },
  ];

  drawerVisible = this.$vuetify.breakpoint.lgAndUp;
  notificationsVisible = false;

  get hideNavbars() {
    return (
      this.$route.fullPath.startsWith("/dashboard/sell/details") ||
      this.$route.fullPath.startsWith("/dashboard/transactions/details") ||
      this.$route.fullPath.startsWith("/dashboard/banks") ||
      this.$route.fullPath.startsWith("/dashboard/profile") ||
      this.$route.fullPath.match(new RegExp("/dashboard/wallets/.+"))
    );
  }

  @AccountModule.State
  account!: IAccount;

  @Inject(EServices.store)
  storeService!: StoreService;

  toggleDrawer() {
    this.drawerVisible = !this.drawerVisible;
  }

  showNotifications() {
    this.notificationsVisible = true;
  }

  async logout() {
    if (this.$vuetify.breakpoint.mdAndDown) this.drawerVisible = false;
    const result = await confirm({ icon: "mdi-power", title: "Log Out" });
    if (!result) return;
    this.storeService.dispatch("clear");
    this.$router.replace("/");
  }

  @Watch("$route")
  async onRouteChange() {
    await delay(100);
    if (
      !this.$route.fullPath.startsWith("/dashboard/transactions") &&
      !this.$route.fullPath.startsWith("/dashboard/banks") &&
      !this.$route.fullPath.startsWith("/dashboard/activities")
    )
      document.querySelector("main")!.style.paddingTop = "64px";
    else document.querySelector("main")!.style.paddingTop = "104px";
  }
}
